import '../styles/App.scss'
import '../styles/CompletedJobDetailed.scss'

import { Job, JobItems, AttachmentParams, JobPrototype } from '../types'
import React from 'react'
import { AppBarContainer } from './CustomAppBar'
import PageTitle from '../components/PageTitle'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { ListItem, FlatButton } from 'material-ui'
import FormattedAddress from '../components/FormattedAddress'
import images from '../images'
import JobUtils from '../utils/JobUtils'
import * as moment from 'moment'
import JobItemDetails from '../components/JobItemDetails'
import { RouterAction, routerActions } from 'react-router-redux'
import { ROUTES } from '../constants/routes'
import { connect } from 'react-redux'
import { Api } from '../services/api/api'
import Lightbox from 'react-images-zoom'
import UploadedImages from '../components/UploadedImages'
import { AdditionalItemStatus } from '../types/enums/AdditionalItemStatus'
import { TIMES } from '../constants/components/pickupTime'
import xstreamConfig from 'recompose/xstreamObservableConfig'

import { BaseContainer } from './BaseContainer'
import { EventType } from '../services/events/events'

import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

import { CustomTextarea } from '../components/CustomTextarea'
import { StickyContainer, Sticky } from 'react-sticky'

import {
    ActionType as ErrorInfoActionType,
    Actions as ErrorActions
} from '../actions/errorInfo'
import { Error as ErrorInfo } from '../types/Errors/Error'
import Mapper from '../utils/Mapper'
import { ContactUsType } from '../types/ContactUs'
import { LocationDescriptor } from 'history'
import { repostJob, SetJobDetailsAction } from '../actions/setJobDetails'
import MessageDialog, { MessageDialogProps } from '../components/MessageDialog'
import { PreferenceType } from '../types/enums'

interface Props {
    job: Job
    routePush: (location: LocationDescriptor) => RouterAction
    onErrorEvent: (errorInfo: ErrorInfo) => ErrorInfoActionType
    repostJob: (
        job: Job,
        attachments: AttachmentParams[]
    ) => SetJobDetailsAction
    hasActiveJob: boolean
}

interface State {
    jobCategoryName: string | undefined
    attachments: AttachmentParams[]
    photoIndex: number
    isImagesBoxOpen: boolean
    messageDialog: MessageDialogProps
    activeJobOnRepostMessage: string
}

export default class CompletedJobDetailed extends React.Component<
    Props,
    State
> {
    constructor(props: Props) {
        super(props)

        this.state = {
            jobCategoryName: JobUtils.getJobCategoryName(this.props.job),
            attachments: [],
            photoIndex: 0,
            isImagesBoxOpen: false,
            messageDialog: {
                isDialogOpened: false
            },
            activeJobOnRepostMessage: ''
        }
    }

    async componentDidMount() {
        const activeJobOnRepostMessage = await Api.getPreference(
            PreferenceType.ActiveJobOnRepostMessage
        )
        this.setState({
            activeJobOnRepostMessage: activeJobOnRepostMessage.value
        })

        Api.getJob(this.props.job.id)
            .then((jobAtt: Job) => {
                this.setState({ attachments: this.getAllFiles(jobAtt) })
            })
            .catch(error => {
                console.log('CompletedJobDetailed get job info error', error)
                this.props.onErrorEvent(Mapper.mapError(error))
            })
    }

    buildCategorySubtitle = (): string => {
        if (this.props.job.jobItems && this.props.job.jobItems.length > 0) {
            let str = ''
            let items: JobItems[] = this.props.job.jobItems
            for (let i = 0; i < items.length; i++) {
                if (items[i].count > 0) {
                    if (str !== '') {
                        str = str + ', '
                    }
                    str = str + items[i].count + ' ' + items[i].subCategoryId
                }
            }
            return str
        } else {
            return ''
        }
    }

    formatDate = (dateFrom: number, dateTo: number): string => {
        if (dateFrom === undefined || dateTo === undefined) {
            return ''
        }
        if (dateFrom === dateTo) {
            return `${moment(this.props.job.futureDateFrom).format(
                'MM/DD/YYYY'
            )} latest ${moment(this.props.job.futureDateFrom).format('h:mm A')}`
        }
        let hFrom = moment(this.props.job.futureDateFrom).format('H')
        let hTo = moment(this.props.job.futureDateTo).format('H')
        let time = TIMES.slice(1).find(x => {
            return hFrom >= x.timeFrom && hTo <= x.timeTo
        })
        let interval = time ? time.interval : 'Any time'
        let date = moment(this.props.job.futureDateFrom).format('MM/DD/YYYY')
        let timeFrom = moment(this.props.job.futureDateFrom).format('h A')
        let timeTo = moment(this.props.job.futureDateTo).format('h A')
        return `${date} ${interval} ${timeFrom} - ${timeTo}`
    }

    getAllFiles = (job: Job) => {
        let allFiles: any[] = []
        if (job.attachments && job.attachments.length !== 0) {
            job.attachments.map(file => {
                allFiles.push({ id: file.id, url: file.url })
            })
        }
        if (
            job.additionalItem &&
            job.additionalItem.status !== AdditionalItemStatus.DECLINED &&
            job.additionalItem.pictures &&
            job.additionalItem.pictures.length !== 0
        ) {
            job.additionalItem.pictures.map(file => {
                allFiles.push({ id: file.id, url: file.url })
            })
        }
        return allFiles
    }

    backToCompletedJobs = () => {
        this.props.routePush(ROUTES.COMPLETED_JOBS)
    }

    onImgBoxClickPrev = () => {
        let { photoIndex, attachments } = this.state
        this.setState({
            photoIndex:
                (photoIndex + attachments.length - 1) % attachments.length
        })
    }
    onImgBoxClickNext = () => {
        let { photoIndex, attachments } = this.state
        this.setState({
            photoIndex: (photoIndex + 1) % attachments.length
        })
    }
    onImgBoxClose = () => {
        this.setState({ isImagesBoxOpen: false })
    }

    onImgIconClick = event => {
        // tslint:disable-next-line:radix
        let iconIndex = parseInt(event.target.id)
        this.setState({ photoIndex: iconIndex, isImagesBoxOpen: true })
    }

    handleSupportClick = () => {
        this.props.routePush({
            pathname: ROUTES.CONTACT,
            state: { type: ContactUsType.Job, data: this.props.job }
        })
    }
    handleRate = () => {
        this.props.repostJob(this.props.job, this.state.attachments)
        this.props.routePush({
            pathname: ROUTES.REVIEW_HAULER,
            state: { fromHistory: true }
        })
    }
    handleRepostClick = async () => {
        if (this.props.hasActiveJob) {
            this.setState({
                messageDialog: {
                    isDialogOpened: true,
                    title: 'Repost job',
                    message: this.state.activeJobOnRepostMessage,
                    actions: [
                        {
                            caption: 'Close',
                            onClick: () => {
                                this.setState({
                                    messageDialog: { isDialogOpened: false }
                                })
                            }
                        }
                    ]
                }
            })
            return
        }

        this.props.repostJob(this.props.job, this.state.attachments)
        this.props.routePush({
            pathname: ROUTES.SET_AVAILABITILY,
            state: { repost: true }
        })
    }

    toLowerCaseExceptFirstChar(str: string): string {
        return str[0] + str.slice(1).toLowerCase()
    }

    render() {
        let showSubtitle: boolean = this.props.job && !!this.props.job.jobItems
        let finalPrice = JobUtils.getFinalAmount(this.props.job)
        let imgSrcs =
            this.state.attachments &&
            this.state.attachments.map(file => {
                return { src: file.url }
            })
        let finalDt = this.formatDate(
            this.props.job.futureDateFrom as number,
            this.props.job.futureDateTo as number
        )

        let textareaMinHeight =
            this.props.job.note && this.props.job.note.length > 54
                ? this.props.job.note.length > 108
                    ? 240
                    : 177
                : 100

        const title = this.toLowerCaseExceptFirstChar(
            this.props.job.status.replace(/_/g, ' ')
        )

        return (
            <BaseContainer pageName={EventType.COMPLETED_JOB}>
                <Lightbox
                    images={imgSrcs ? imgSrcs : []}
                    currentImage={this.state.photoIndex}
                    showImageCount={true}
                    isOpen={this.state.isImagesBoxOpen}
                    onClickPrev={this.onImgBoxClickPrev}
                    onClickNext={this.onImgBoxClickNext}
                    onClose={this.onImgBoxClose}
                    rotatable={true}
                    zoomable={true}
                />
                <AppBarContainer
                    isIconButtonsShown={true}
                    isMenuShown={false}
                />
                <PageTitle
                    text={`${title} - ${this.props.job.idHumanReadable}`}
                />
                <PerfectScrollbar className="completed-job-scrollbar">
                    <div className="job-details-list">
                        <ListItem
                            className="job-details-list-item"
                            disabled={true}
                            leftAvatar={
                                <img
                                    className="map-icon"
                                    src={images.pickupLocation}
                                />
                            }
                            primaryText={StringResources.getString(
                                Strings.CompletedJobsItem.Text.JobLocation
                            )}
                            secondaryText={
                                <div>
                                    <FormattedAddress
                                        address={this.props.job.address}
                                    />
                                </div>
                            }
                            secondaryTextLines={2}
                        />
                        <ListItem
                            className="job-details-list-item"
                            disabled={true}
                            leftAvatar={
                                <img
                                    className="job-icon"
                                    src={JobUtils.getImageForCategory(
                                        this.props.job.jobCategory
                                            ? this.props.job.jobCategory
                                            : images.quickHaul
                                    )}
                                />
                            }
                            primaryText={this.state.jobCategoryName}
                            secondaryText={
                                showSubtitle ? (
                                    <p>
                                        <span>
                                            {this.buildCategorySubtitle()}
                                        </span>
                                        <br />
                                        <span>
                                            {finalPrice
                                                ? `${StringResources.getString(
                                                      Strings.CompletedJobsItem
                                                          .Text.Price
                                                  )}${finalPrice}`
                                                : ''}
                                        </span>
                                    </p>
                                ) : (
                                    <p>
                                        <br />
                                    </p>
                                )
                            }
                            secondaryTextLines={2}
                        />
                        <ListItem
                            className="job-details-list-item"
                            disabled={true}
                            leftAvatar={
                                <img
                                    className="calendar-icon-published"
                                    src={images.calendar}
                                />
                            }
                            primaryText={StringResources.getString(
                                Strings.CompletedJobsItem.Text.JobTime
                            )}
                            secondaryText={
                                <p>
                                    {
                                        <span>
                                            {finalDt}
                                            <br />
                                        </span>
                                    }
                                </p>
                            }
                            secondaryTextLines={2}
                        />
                        <div className="uploaded_img">
                            {this.state.attachments
                                ? this.state.attachments.map((file, index) => (
                                      <UploadedImages
                                          key={file.id}
                                          handleIconClick={this.onImgIconClick}
                                          file={file}
                                          index={index}
                                          isBadgeNeeded={false}
                                      />
                                  ))
                                : null}
                        </div>

                        <div>
                            <JobItemDetails
                                completedJob={this.props.job}
                                areStairsNeeded={
                                    this.props.job.areStairsNeeded
                                        ? true
                                        : false
                                }
                                isElevatorNeeded={
                                    this.props.job.isElevatorNeeded
                                        ? true
                                        : false
                                }
                                areItemsOutside={
                                    this.props.job.areItemsOutside
                                        ? true
                                        : false
                                }
                                areItemsInside={
                                    this.props.job.areItemsInside ? true : false
                                }
                            />
                            {this.props.job.note ? (
                                <CustomTextarea
                                    text={this.props.job.note}
                                    classes="published-client-comment"
                                />
                            ) : null}
                        </div>
                    </div>
                </PerfectScrollbar>
                <StickyContainer
                    className={
                        textareaMinHeight > 177
                            ? 'sticky-footer'
                            : 'sticky-footer sb'
                    }
                >
                    <Sticky>
                        {() => (
                            <div className={'job-item__buttons'}>
                                {JobUtils.isCancelledJob(this.props.job) && (
                                    <div
                                        className={
                                            'hover job-item__button-hover'
                                        }
                                    >
                                        <FlatButton
                                            label={StringResources.getString(
                                                Strings.CompletedJobsItem
                                                    .Buttons.Repost.label
                                            )}
                                            className={`flatbutton job-item__button`}
                                            onClick={this.handleRepostClick}
                                        />
                                    </div>
                                )}
                                {(!this.props.job.rated ||
                                    !this.props.job.rated.byClient) &&
                                    JobUtils.isCompletedJob(this.props.job) && (
                                        <div
                                            className={
                                                'hover job-item__button-hover'
                                            }
                                        >
                                            <FlatButton
                                                label={StringResources.getString(
                                                    Strings.CompletedJobsItem
                                                        .Buttons.Rate.label
                                                )}
                                                className={`flatbutton job-item__button`}
                                                onClick={this.handleRate}
                                            />
                                        </div>
                                    )}
                                <div className={'hover job-item__button-hover'}>
                                    <FlatButton
                                        label={StringResources.getString(
                                            Strings.CompletedJobsItem.Buttons
                                                .Support.label
                                        )}
                                        onClick={this.handleSupportClick}
                                        className="flatbutton job-item__button"
                                    />
                                </div>
                            </div>
                        )}
                    </Sticky>
                </StickyContainer>
                <MessageDialog {...this.state.messageDialog} />
            </BaseContainer>
        )
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        job: state.completedJob,
        hasActiveJob: JobUtils.isActiveJob(state.jobDetails)
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        repostJob: (job: Job, attachments: AttachmentParams[]) =>
            dispatch(repostJob(job, attachments)),
        routePush: (location: string) => dispatch(routerActions.push(location)),
        onErrorEvent: (errorInfo: ErrorInfo) =>
            dispatch(ErrorActions.newError(errorInfo))
    }
}

export const CompletedJobDetailedContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CompletedJobDetailed)



// WEBPACK FOOTER //
// ./src/containers/CompletedJobDetailedContainer.tsx